import type { SupportMessageAudience } from '@/types/messages/supportMessage';

export type MessageTemplateCategory = string;

/**
 * Which participant of the open inquiry a template is written for, reusing the
 * support-message roles: `submitter` shows on the thread routed to Ask Anonymously,
 * `recipient` on the thread Ask Anonymously forwarded to an expert.
 */
export type MessageTemplateAudience = SupportMessageAudience;

export type MessageTemplate = {
  id: string;
  title: string;
  body: string;
  category: MessageTemplateCategory;
  audience: MessageTemplateAudience;
};

export type TemplateVariables = {
  submitter: string;
  /** The submitter's first name alone, for a templated "Hi {submitterFirst}". */
  submitterFirst: string;
  /** The submitter's last name alone, for "Dr. {submitterLast}" whether or not they identify as a doctor. */
  submitterLast: string;
  expert: string;
};

export function interpolateTemplate(body: string, variables: TemplateVariables): string {
  return body
    .replace(/\{submitterFirst\}/g, variables.submitterFirst)
    .replace(/\{submitterLast\}/g, variables.submitterLast)
    .replace(/\{submitter\}/g, variables.submitter)
    .replace(/\{expert\}/g, variables.expert);
}

/** `both` templates show on either thread. */
export function isTemplateForAudience(
  template: Pick<MessageTemplate, 'audience'>,
  audience: Exclude<MessageTemplateAudience, 'both'>
): boolean {
  return template.audience === audience || template.audience === 'both';
}
